import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(res.data);
        // Clear fragment and go to admin
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        const status = e?.response?.status;
        if (status === 403) {
          navigate("/admin/login?error=forbidden", { replace: true });
        } else {
          navigate("/admin/login?error=session", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A192F] text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-heading text-2xl">Sitzung wird geprüft…</div>
        <div className="mt-2 text-sm text-slate-400">Bitte einen Moment Geduld.</div>
      </div>
    </div>
  );
}
